import script from "./SimpleCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./SimpleCard.vue?vue&type=script&setup=true&lang=ts"

import "./SimpleCard.vue?vue&type=style&index=0&id=4e503c10&lang=css"

const __exports__ = script;

export default __exports__